import React, { FC } from 'react';
import { Box, ButtonBase } from '@material-ui/core';
import { MdClose as CloseIcon } from '@react-icons/all-files/md/MdClose';
import api from 'src/config/api';

interface Props {
  onDelete: () => void;
  logoId: string;
}

const SiteLogo: FC<Props> = ({ onDelete, logoId }) => {
  const { endpoint } = api.document.download(logoId);

  return (
    <Box display='flex' justifyContent='center'>
      <Box position='relative' borderRadius={10} overflow='hidden'>
        <Box maxHeight='120px' maxWidth='350px' height='100%' style={{ objectFit: 'contain' }} clone>
          <img src={endpoint} alt='Logo' />
        </Box>

        <Box
          display='flex'
          alignItems='center'
          justifyContent='center'
          borderRadius='50%'
          top='6px'
          right='6px'
          p='2px'
          position='absolute'
          bgcolor='#161c24b8'
          clone
        >
          <ButtonBase onClick={onDelete}>
            <CloseIcon color='white' />
          </ButtonBase>
        </Box>
      </Box>
    </Box>
  );
};

export default SiteLogo;
